module.exports = __webpack_public_path__ + "img/27.74c2c188.jpg";